module.exports = "<div class=\"container d-flex flex-column offset-lg-1\">\n  <div class=\"row\">\n    <h2>Abstracts</h2>\n  </div>\n  <div class=\"row offset-1\">\n    <p>File with abstracts:</p>\n    <ul>\n      <li><a href=\"../../assets/ammpb2-abstracts.pdf\" target=\"_blank\">Normal</a></li>\n      <li><a href=\"../../assets/ammpb2-abstracts-small.pdf\" target=\"_blank\">Small file size</a></li>\n    </ul>\n\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/rzonsol/WebstormProjects/ammpb2/src/app/abstracts/abstracts.component.html
// module id = ../../../../../src/app/abstracts/abstracts.component.html
// module chunks = main